<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <div class="mb-3">
    <QueryField :is-disabled="isQueryDisabled" :condition.sync="conditionValue" />
    <ContextField :is-disabled="isContextDisabled" :condition.sync="conditionValue" />
    <FiltersField :is-disabled="isFilterDisabled" :condition.sync="conditionValue" />
  </div>
</template>

<script setup>

import { ref, computed } from 'vue';

import { useStore } from 'vue2-helpers/vuex';
import QueryField from './ConditionFormsFields/QueryField.vue';
import ContextField from './ConditionFormsFields/ContextField.vue';
import FiltersField from './ConditionFormsFields/FiltersField.vue';

const store = useStore();

const props = defineProps({
  condition: { type: Object, default: null },
  conditions: { type: Array, default: [] }
});
const conditionValue = ref(props.condition);

const multipleConditions = computed(() => props.conditions.length > 1);

const isSpeedboat = computed(() => store.state.environment.PROJECT === 'speedboat');

const isQueryDisabled = computed(() => {
  if (isSpeedboat.value) {
    return conditionValue.value.hasContext;
  }
  return !conditionValue.value.hasContext && !conditionValue.value.hasFilter;
});

const isFilterDisabled = computed(() => {
  if (isSpeedboat.value) {
    return conditionValue.value.hasContext;
  }
  return !conditionValue.value.hasQuery && !conditionValue.value.hasContext;
});

const isContextDisabled = computed(() => {
  if (isSpeedboat.value) {
    return multipleConditions.value || conditionValue.value.hasQuery || conditionValue.value.hasFilter;
  }
  return !conditionValue.value.hasQuery && !conditionValue.value.hasFilter;
});

</script>
<style>
</style>
